import React, { useRef, useContext, useEffect, useState } from 'react'
import CookieConsent from 'react-cookie-consent'
import Button from 'components/ui-elements/button'
import { Wrap, Content, Buttons, ButtonClose } from './index.styled'
import { ThemeContext } from 'styles/theme-provider'
import { useLocation } from '@reach/router'

const CookiesBanner = () => {
  const ref = useRef()
  const refCookie = useRef()
  const { showSplash } = useContext(ThemeContext)
  const [isShow, setIsShow] = useState(true)
  const location = useLocation()

  useEffect(() => {
    if (!isShow) return
    const delay = showSplash && location.pathname === '/' ? 7500 : 2000
    if (showSplash && location.pathname === '/') {
      ref?.current?.classList?.remove('show')
    }
    const timeout = setTimeout(() => {
      ref?.current?.classList?.add('show')
    }, delay)
    return () => clearTimeout(timeout)
  }, [showSplash, location.pathname, isShow])

  const onClose = () => {
    ref?.current?.classList?.remove('show')
    setIsShow(false)
  }

  return (
    <Wrap ref={ref}>
      <CookieConsent
        ref={refCookie}
        location='none'
        buttonText='ok'
        disableStyles
        containerClasses='cookies-banner'
        buttonClasses='cookies-banner-accept-btn'
        disableButtonStyles
        buttonWrapperClasses='cookies-banner-btns'
        contentClasses='cookies-banner-content'
        expires={150}
        // debug={true}
      >
        <Content className='t2'>
          This website uses cookies to ensure you get the best experience on our website.{' '}
          <Buttons>
            <Button
              className='white-bg-hover-bg-terracotta'
              as='button'
              type='button'
              onClick={() => refCookie.current?.accept()}
              $width='150'
              $widthMobile='100'
            >
              ACCEPT
            </Button>
            <Button
              className='learn-more'
              href='https://www.cookiesandyou.com'
              target='_blank'
              as='a'
              $width='150'
              $widthMobile='100'
            >
              Learn more
            </Button>
          </Buttons>
        </Content>
        <ButtonClose onClick={onClose} />
      </CookieConsent>
    </Wrap>
  )
}
export default CookiesBanner
